module.exports = __webpack_public_path__ + "img/concrete-hole-decal-10.3aa18220.png";